import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'projects/sepidz-web-framework-shell/src/lib/shared/shared.module';
import { SepidzGridModule } from 'projects/sepidz-web-framework-data-grid/src/lib/grid.module';
import { ZoneFormComponent } from './zone/zone-form.component';
import { ZoneListComponent } from './zone/zone-list.component';
import { CustomerCategoryFormComponent } from './customer-category/customer-category-form.component';
import { CustomerCategoryListComponent } from './customer-category/customer-category-list.component';
import { CustomerFormComponent } from './customer/customer-form.component';
import { CustomerListComponent } from './customer/customer-list.component';
import { PersonnelFormComponent } from './personnel/personnel-form.component';
import { PersonnelListComponent } from './personnel/personnel-list.component';
import { ZonePriceAnnouncementFormComponent } from './zone-price-announcement/zone-price-announcement-form/zone-price-announcement-form.component';
import { ZonePriceAnnouncementListComponent } from './zone-price-announcement/zone-price-announcement-list/zone-price-announcement-list.component';
import { FilterDriversByCodeComponent } from './filter-drivers-by-code/filter-drivers-by-code.component';
import { MapComponent } from './map/map.component';

  const components =
  [
    ZoneFormComponent,
    ZoneListComponent,  
    CustomerCategoryFormComponent,
    CustomerCategoryListComponent,
    CustomerFormComponent,
    CustomerListComponent,
    PersonnelFormComponent,
    PersonnelListComponent,
    ZonePriceAnnouncementFormComponent,
    ZonePriceAnnouncementListComponent,
    FilterDriversByCodeComponent,
    MapComponent,
  ]
@NgModule({
    declarations: [...components],
    exports: [...components],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule.forRoot(),
        SepidzGridModule
    ]
})
export class PartiesModule { }
